import { FieldConfigBuilder } from './FieldConfigBuilder.js';
import { PanelOptionsBuilder } from './PanelOptionsBuilder.js';

class VizConfigBuilder {
  constructor(pluginId, pluginVersion, defaultOptions, defaultFieldConfig) {
    this._pluginId = pluginId;
    this._pluginVersion = pluginVersion;
    this._fieldConfigBuilder = new FieldConfigBuilder(defaultFieldConfig);
    this._panelOptionsBuilder = new PanelOptionsBuilder(defaultOptions);
  }
  /**
   * Set color.
   */
  setColor(color) {
    this._fieldConfigBuilder.setColor(color);
    return this;
  }
  /**
   * Set number of decimals to show.
   */
  setDecimals(decimals) {
    this._fieldConfigBuilder.setDecimals(decimals);
    return this;
  }
  /**
   * Set field display name.
   */
  setDisplayName(displayName) {
    this._fieldConfigBuilder.setDisplayName(displayName);
    return this;
  }
  /**
   * Set the standard field config property filterable.
   */
  setFilterable(filterable) {
    this._fieldConfigBuilder.setFilterable(filterable);
    return this;
  }
  /**
   * Set data links.
   */
  setLinks(links) {
    this._fieldConfigBuilder.setLinks(links);
    return this;
  }
  /**
   * Set value mappings.
   */
  setMappings(mappings) {
    this._fieldConfigBuilder.setMappings(mappings);
    return this;
  }
  /**
   * Set the standard field config property max.
   */
  setMax(max) {
    this._fieldConfigBuilder.setMax(max);
    return this;
  }
  /**
   * Set the standard field config property min.
   */
  setMin(min) {
    this._fieldConfigBuilder.setMin(min);
    return this;
  }
  /**
   * Set the standard field config property noValue.
   */
  setNoValue(noValue) {
    this._fieldConfigBuilder.setNoValue(noValue);
    return this;
  }
  /**
   * Set the standard field config property thresholds.
   */
  setThresholds(thresholds) {
    this._fieldConfigBuilder.setThresholds(thresholds);
    return this;
  }
  /**
   * Set the standard field config property unit.
   */
  setUnit(unit) {
    this._fieldConfigBuilder.setUnit(unit);
    return this;
  }
  setCustomFieldConfig(id, value) {
    this._fieldConfigBuilder.setCustomFieldConfig(id, value);
    return this;
  }
  setOverrides(builder) {
    this._fieldConfigBuilder.setOverrides(builder);
    return this;
  }
  /**
   * Set an individual panel option. This will merge the value with the existing options.
   */
  setOption(id, value) {
    this._panelOptionsBuilder.setOption(id, value);
    return this;
  }
  /**
   * Build the panel.
   */
  build() {
    return {
      pluginId: this._pluginId,
      pluginVersion: this._pluginVersion,
      options: this._panelOptionsBuilder.build(),
      fieldConfig: this._fieldConfigBuilder.build()
    };
  }
}

export { VizConfigBuilder };
//# sourceMappingURL=VizConfigBuilder.js.map
